import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

export default function Student360Expired({ connectionError = false, diagnosticId, onRetry } = {}) {
  const location = useLocation();
  const navigate = useNavigate();
  const trace = diagnosticId || location.state?.diagnosticId;
  const validTrace = /^[a-f0-9]{16}$/.test(trace || '') ? trace : '';
  function retry() {
    if (onRetry) { onRetry(); return; }
    const from = location.state?.from;
    const allowed = ['/student360', '/mini-tasks/parent', '/puanlarim', '/avatarim', '/odemelerim'];
    navigate(allowed.includes(from?.pathname) ? { pathname: from.pathname, search: from.search || '' } : '/student360', { replace: true });
  }
  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: '#f8fafc',
        padding: 16,
      }}
    >
      <div
        style={{
          width: '100%',
          maxWidth: 520,
          background: '#ffffff',
          border: '1px solid #e2e8f0',
          borderRadius: 14,
          padding: 24,
          boxShadow: '0 8px 24px rgba(15, 23, 42, 0.06)',
          textAlign: 'center',
        }}
      >
        <h1 style={{ margin: 0, fontSize: 24, color: '#0f172a' }}>{connectionError ? 'Bağlantı Kontrol Edilemedi' : 'Oturum Doğrulanamadı'}</h1>
        <p style={{ marginTop: 12, marginBottom: 0, fontSize: 15, lineHeight: 1.6, color: '#475569' }}>
          {connectionError
            ? 'Bağlantınızı şu anda kontrol edemedik. İnternet bağlantınızı kontrol edip yeniden deneyin.'
            : 'Bu tarayıcıda geçerli bir oturum bulunamadı. Yeniden deneyin veya WhatsApp üzerinden öğrenci360 yazarak yeni bağlantı isteyin. En son gönderilen bağlantıyı açın.'}
        </p>
        <button type="button" onClick={retry} style={{ marginTop: 20, padding: '12px 20px', background: '#0f172a', color: '#ffffff', border: 0, borderRadius: 10, fontSize: 16, cursor: 'pointer' }}>Yeniden dene</button>
        {validTrace && <p style={{ marginBottom: 0, fontSize: 13, color: '#64748b' }}>Takip kodu: {validTrace}</p>}
      </div>
    </div>
  );
}

